import { Link } from "react-router-dom";
import { Wrench, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-neutral-800 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 bg-yellow-400 flex items-center justify-center rounded-sm">
              <Wrench className="w-5 h-5 text-black" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-extrabold text-xl text-white">Easy Stop Mobile Service</span>
          </div>
          <p className="text-neutral-400 text-sm max-w-md leading-relaxed">
            We bring the garage to your driveway. Certified mobile mechanics, transparent pricing,
            and a deposit-secured booking so your slot is always reserved.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-yellow-400 font-bold mb-4">Navigate</h4>
          <ul className="space-y-3 text-sm text-neutral-300">
            <li><Link to="/" className="hover:text-yellow-400 transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-yellow-400 transition-colors">Services</Link></li>
            <li><Link to="/book" className="hover:text-yellow-400 transition-colors">Book a Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-yellow-400 font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-neutral-300">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-yellow-400" /> 704-774-5204</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-yellow-400" /> support@easystopservice.com</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-yellow-400" /> Charlotte Metro Area</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800 py-6 text-center text-xs text-neutral-500 uppercase tracking-wider">
        © {new Date().getFullYear()} Easy Stop Mobile Service — Mon–Fri 8AM–10PM · Sat–Sun 8AM–9PM
      </div>
    </footer>
  );
}
